module.exports = __webpack_public_path__ + "td/img/bind-wx.13b5c224.png";